import React, { useState } from 'react';
import { Grid, Box, Card, Typography, TextField, AppBar, Toolbar, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClipLoader from 'react-spinners/ClipLoader';
import DropLabConfirm from './DropLabConfirm';



function LabConsolleDroppedPage(props) {
    const [isSubmitted, setIsSubmitted] = useState(0);
    const [isSubmitble, setIsSubmitble] = useState(false);
    const [isLoading, setIsLoading] = useState(0);
    const [statusRequest, setStatusRequest] = useState();

    const {
        labProps,
    } = props;


    const onSubmit = (e) => {
        e.preventDefault();
        var formBody = [];
        var url;

        url = process.env.REACT_APP_URL_DROP_LAB;
        console.log("url: " + url)

        const payload = (
            {
                idLab: labProps.idLab,
                labVersion: labProps.labVersion,
                labType: labProps.labType,
                labName: labProps.labName,
                status: labProps.status,
                ...(labProps.clusterType ? { clusterType: labProps.clusterType } : {}),
            }
        );

        formBody.push("payload=" + JSON.stringify(payload));

        setTimeout(async () => {
            console.log("payload: " + JSON.stringify(payload));
            setIsLoading(1);
            await fetch(url, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            })
                .then((resp) => {
                    return resp.json()
                })
                .then((data) => {
                    console.log(JSON.stringify(data));
                    setIsSubmitted(1);
                    setIsLoading(0);
                    setStatusRequest(data.statusRequest);
                    setIsSubmitble(true);
                })
                .catch((error) => {
                    console.log(error, "Errore!")
                });
        });
    }

    if (!labProps) {
        return (
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar>
                    <IconButton edge="start" onClick={() => props.setIsShowDropLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                        Cancellazione Laboratorio Virtuale
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }

    return (
        <React.Fragment>
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar sx={{ gap: 2 }}>
                    <IconButton edge="start" onClick={() => props.setIsShowDropLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="h6" noWrap sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                            Cancellazione Laboratorio Virtuale
                        </Typography>
                        <Typography variant="body2" color="textSecondary" noWrap>
                            {labProps.labName} &mdash; {labProps.baseImage.name} ({labProps.baseImage.size})
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ p: 3 }}>
                <form onSubmit={onSubmit}>

                    <Grid container spacing={2} style={{ width: "100%" }}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">E-mail richiedente</Typography>
                            <TextField
                                fullWidth
                                type="text"
                                placeholder={`${labProps.email}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Identificativo Laboratorio</Typography>
                            <TextField
                                fullWidth
                                type="text"
                                placeholder={`${labProps.idLab}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Tipologia Laboratorio</Typography>
                            <TextField
                                fullWidth
                                type="text"
                                placeholder={`${labProps.labType}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Sistema Operativo</Typography>
                            <TextField
                                fullWidth
                                type="text"
                                placeholder={`${labProps.baseImage.os}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Immagine base</Typography>
                            <TextField
                                fullWidth
                                type="text"
                                placeholder={`${labProps.baseImage.name}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="outlined"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Attività didattica collegata al laboratorio virtuale</Typography>
                            <Card style={{ padding: '1rem' }}>
                                <Typography variant="subtitle2">Descrizione attività didattica</Typography>
                                <TextField
                                    fullWidth
                                    type="text"
                                    placeholder={`${labProps.adSel.anaAfDescIta}`}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                    margin="normal"
                                />
                                <Typography variant="subtitle2">Descrizione modulo</Typography>
                                <TextField
                                    fullWidth
                                    type="text"
                                    placeholder={`${labProps.adSel.anaModDescIta}`}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                    margin="normal"
                                />
                                <Typography variant="subtitle2">Codice Easy</Typography>
                                <TextField
                                    fullWidth
                                    type="text"
                                    placeholder={`${(labProps.adSel?.easyAd || []).map(ea => ea.easyAdCod).join(', ')}`}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                    margin="normal"
                                />
                            </Card>
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 3 }}>
                        <DropLabConfirm
                            isSubmitted={isSubmitted}
                            isSubmitble={isSubmitble}
                            statusRequest={statusRequest}
                            apiAuthGroups={props.apiAuthGroups}
                            buttonDescription={"Cancella il laboratorio"}
                        />
                        <ClipLoader
                            size={35}
                            color={"#a71e3b"}
                            loading={isLoading}
                        />
                    </Box>

                </form>
            </Box>
        </React.Fragment>
    );

}

export default LabConsolleDroppedPage;
